import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { userInfoBackend } from './user-info.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { userInfoReducer } from './user-info.reducer';

// FIXME: remove that
backend.userInfo = userInfoBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('userInfo', userInfoReducer),
    /* DatastoreBackendModule.forFeature(
      'userInfo',
      userInfoBackend,
    ),*/
  ],
})
export class DatastoreUserInfoModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-info/user-info.module.ts